module.exports = __webpack_public_path__ + "static/media/blur.e28d967a.png";